"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_etag_cache_1 = __importDefault(require("axios-etag-cache"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var useInterval_1 = __importDefault(require("./useInterval"));
var useMemoCompare_1 = __importDefault(require("./useMemoCompare"));
var react_1 = require("react");
function fetchCms(wid, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, sid, _b, alwaysReturnCachedResponse, _c, env, sidString, API_CMS, axios;
        return __generator(this, function (_d) {
            _a = options.sid, sid = _a === void 0 ? '' : _a, _b = options.alwaysReturnCachedResponse, alwaysReturnCachedResponse = _b === void 0 ? false : _b, _c = options.env, env = _c === void 0 ? '' : _c;
            sidString = sid ? "/snapshot/" + sid : '';
            API_CMS = options.apiUrl || "https://widgetstate" + (env ? '-' + env : '') + ".votenow.tv/v1/state/";
            axios = axios_etag_cache_1.default({
                baseURL: API_CMS,
                url: "" + wid + sidString
            });
            return [2 /*return*/, axios
                    .get("" + API_CMS + wid + sidString)
                    .then(function (res) {
                    if (!('etag' in res.headers) && !alwaysReturnCachedResponse) {
                        return null;
                    }
                    return __assign({ metadata: {
                            current_timestamp: Math.floor(parseInt(res.data.current_timestamp) / 1000),
                            current_timestamp_ms: res.data.current_timestamp,
                            snapshot_start_timestamp: res.data.snapshot.schedule,
                            name: res.data.snapshot.name,
                        }, sid: res.data.snapshot.snapshot_id, ts: res.data.current_timestamp, name: res.data.name }, res.data.snapshot.data);
                })
                    .catch(function () {
                    return null;
                })];
        });
    });
}
/**
 * Hook for polling a Connect Widget. Will poll once immediately, and then on the specified polling frequency (default = 5 seconds)
 * Accepts an options list with the following defaults if not specified:
 * pollingFrequency: null,
 * sid: '',
 * alwaysReturnCachedResponse: false
 * @param wid widget ID to poll
 * @param options list of options
 * @example
 * // Basic Usage (polls every 5 seconds)
 * const [cmsData] = useCMS('91600027c41332db')
 *
 * // Polls a widget using specific snapshotID
 * const [cmsData] = useCMS('91600027c41332db', {sid: 103119 })
 *
 * // polls every 3 seconds
 * const [cmsData] = useCMS('91600027c41332db', {pollingFrequncy: 3000})
 */
function useCMS(wid, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.pollingFrequency, pollingFrequency = _a === void 0 ? null : _a, _b = options.sid, sid = _b === void 0 ? '' : _b, _c = options.alwaysReturnCachedResponse, alwaysReturnCachedResponse = _c === void 0 ? false : _c, _d = options.env, env = _d === void 0 ? '' : _d, _e = options.apiUrl, apiUrl = _e === void 0 ? undefined : _e;
    var cachedOptions = useMemoCompare_1.default(options, function (prev, next) {
        return isEqual_1.default(prev, next);
    });
    var _f = react_1.useState(null), cmsData = _f[0], setCmsData = _f[1];
    var callback = react_1.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var opts, data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    opts = {
                        sid: sid,
                        pollingFrequency: pollingFrequency,
                        alwaysReturnCachedResponse: cmsData ? alwaysReturnCachedResponse : true,
                        env: env,
                        apiUrl: apiUrl
                    };
                    if (!wid) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchCms(wid, opts)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = null;
                    _b.label = 3;
                case 3:
                    data = _a;
                    setCmsData(function (prevState) {
                        if (!data)
                            return prevState;
                        return data;
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [cachedOptions, wid, cmsData]);
    // Don't set an interval unless pollingFrequency is set
    var shouldCallImediately = !!pollingFrequency;
    useInterval_1.default(callback, pollingFrequency, shouldCallImediately, false);
    return [cmsData, callback];
}
exports.default = useCMS;
//# sourceMappingURL=useCMS.js.map